import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

import { Client } from 'src/providers/client/client';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { Me } from 'src/providers/me/me';

import { ClientSettingsModel } from 'src/models/client.model';
import { TidySelectStringValueModel } from 'src/models/tidy-select-item.model';
import { WindowService } from 'src/shared/providers/window.service';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { SuccessPage } from 'src/shared/pages/success/success';

@Component({
    templateUrl: 'account-type.html',
    standalone: false
})

export class AccountTypePage implements OnInit {

  accountTypes: TidySelectStringValueModel[];
  form: UntypedFormGroup;
  loaded: boolean;
  settings: ClientSettingsModel;
  updatedSettings: {profile: {account_type: string}};
  isRightSideContent = true;
  dialogParams: any;

  
  boundSave = this.save.bind(this);

constructor(
    private client: Client,
    private fb: UntypedFormBuilder,
    private me: Me,
    private navCtrl: CustomNavController,
    private windowService: WindowService,
    private storage: TidyStorage,
    private rightSidePanelService: RightSidePanelService
  ) {
    this.form = this.fb.group({
      type: ['', Validators.required],
    });
  }

  async ngOnInit() {
    this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
    this.rightSidePanelService.setDialogPageTitle('Edit Account Type');
    if (this.isRightSideContent) {
      this.dialogParams = await this.storage.retrieve('dialog-params');
    }
    this.loaded = false;
    this.settings = this.dialogParams?.settings ?? this.navCtrl.getParam('settings') ?? await this.client.getClientSettings();
    this.accountTypes = [
      {viewValue: 'For my Home', value: 'regular'},
      {viewValue: 'I Manage an Airbnb/Rental', value: 'rental'},
      {viewValue: 'For an Office', value: 'company'}
    ];
    this.form.patchValue({
      type: this.settings.profile.account_type
    });
    this.loaded = true;
  }

  async save() {
    const type = this.form.value.type;
    this.updatedSettings = {
      profile: {
        account_type: type
      }
    }
    localStorage.setItem('isRentalClient', type === 'rental' ? 'true' : 'false');
    localStorage.setItem('accountType', type);
    await this.client.saveClientSettings(this.updatedSettings);
    await this.me.load(true);
    const params = this.mountSuccessPageParams();
    localStorage.setItem('shouldReloadLocation', 'true');
    localStorage.setItem('didMakeMoreChange', 'true');
    this.rightSidePanelService.navigateTo('success', params, SuccessPage);
  }

  mountSuccessPageParams() {
    return {
      header: 'Account Type Updated',
      body: '',
      buttonText: 'Ok',
      buttonRoute: 'more'
    };
  }

}
